import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fetchGaMeasurementId } from "./gaApi";

function injectGtag(id) {
  if (!id) return;
  if ((window.__GA_MEASUREMENT_ID || '') === id) return; // already loaded for this id

  // Remove previous gtag script if measurement changed
  const existing = document.querySelector('script[data-ga="gtag"]');
  if (existing) existing.remove();

  // Initialize dataLayer and stub gtag to queue events until script loads
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;

  // Add gtag script tag
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  s.dataset.ga = "gtag";
  s.onload = () => {
    if (typeof window.gtag === 'function') {
      window.gtag('js', new Date());
      window.gtag('config', id, { send_page_view: false });
      sendPageView();
    }
  };
  document.head.appendChild(s);

  window.__GA_MEASUREMENT_ID = id;
}

function sendPageView() {
  if (typeof window.gtag === 'function' && window.__GA_MEASUREMENT_ID) {
    window.gtag('event', 'page_view', { page_path: window.location.pathname });
  }
}

export default function GaManager() {
  const location = useLocation();

  useEffect(() => {
    let mounted = true;
    fetchGaMeasurementId()
      .then((id) => {
        if (!mounted) return;
        if (id) {
          injectGtag(id);
          // send a page view for initial load
          sendPageView();
        } else {
          // no id -> ensure no script
          const existing = document.querySelector('script[data-ga="gtag"]');
          if (existing) existing.remove();
          window.__GA_MEASUREMENT_ID = '';
        }
      })
      .catch(() => {
        // silence failure
      });

    return () => { mounted = false };
  }, []);

  useEffect(() => {
    // on navigation, refresh GA measurement id (in case admin updated it)
    let mounted = true;
    fetchGaMeasurementId()
      .then((id) => {
        if (!mounted) return;
        if (id && id !== (window.__GA_MEASUREMENT_ID || '')) {
          injectGtag(id);
        }
        sendPageView();
      })
      .catch(() => {
        sendPageView();
      });

    return () => { mounted = false };
  }, [location.pathname]);

  useEffect(() => {
    const listener = () => {
      fetchGaMeasurementId()
        .then((id) => {
          if (id && id !== (window.__GA_MEASUREMENT_ID || '')) {
            injectGtag(id);
            sendPageView();
          }
        })
        .catch(() => {});
    };

    window.addEventListener('site:ga-updated', listener);
    return () => window.removeEventListener('site:ga-updated', listener);
  }, []);

  return null;
}
